<template>
  <div class="filtros">
    <div class="form-group">
      <input-mapeo label="Bodega" attr="bodegaId" @changeInput="loadFiltros"/>
      <input-mapeo label="Sector" attr="sectorId" @changeInput="loadFiltros"/>
      <input-mapeo label="Metro" attr="metroId" @changeInput="loadFiltros"/>
      <select-form label="Sucursal" :options="sucursales" name="sucursal_id" v-model="sucursalId"/>
    </div>
    <button class="btn btn-micro btn-info" @click="filtrar">Filtrar</button>
  </div>
</template>

<script>
import InputMapeo from "components/Bodega/Components/inputMapeo";
import SelectForm from "components/Finanzas/Components/select-form";
export default {
  name: "FiltrosMapeoBodega",
  components: {SelectForm, InputMapeo},
  methods: {
    loadFiltros({attr, value}) {
      this[attr] = value
    },
    filtrar() {
      this.$emit('filtrar', {
        bodega_id: this.bodegaId,
        sector_id: this.sectorId,
        metro_id: this.metroId,
        sucursal_id: this.sucursalId.value || ''
      })
    }
  },
  data() {
    return {
      bodegaId: '',
      metroId: '',
      sectorId: '',
      sucursalId: ''
    }
  },
  computed:{
    sucursales() {
      return [
        {
          value: 'bb6f5f9f-89ff-4843-bf49-565ab6bde315',
          label: 'Coquimbo'
        },
        {
          value: 'b7c0fe97-ac66-49bb-b9ab-7f53c96b4e2f',
          label: 'La Serena'
        },
        {
          value: 'eba2f3f2-1483-4137-abaf-12ceed5a67cd',
          label: 'Andacollo'
        },
        {
          value: '4d6303a6-ffe8-4abc-b3a2-5a3a3d9fd117',
          label: 'Web'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
